import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "./config";
import { ErrorResponsesCreateOrUpdate, Records } from "../types/records.types";
import { MutationOptions } from "../types/mutation.types";

export const useUpdateRecords = (options?: MutationOptions) => {
    const queryClient = useQueryClient();
    return useMutation<any, ErrorResponsesCreateOrUpdate, Records, any>({
        mutationFn: (records: Records) => updateRecord(records),
        onSuccess(data, variables) {
            const recordsKey = options?.queryInvalidatePrefix || `${variables.entity}-records`;

            const invalidationKeys = [recordsKey];

            invalidationKeys.forEach((key) => {
                queryClient.invalidateQueries({
                    predicate(query: any) {
                        return query.queryKey[0].includes(key);
                    },
                });
            });
        },
        onError(error: ErrorResponsesCreateOrUpdate) {
            return error.response.data.errors[0].message;
        },
    });
};

export const updateRecord = async (records: Records) => {
    const updatedRecord = await api({
        method: "PATCH",
        url: `items/${records.entity}`,
        data: records.data,
    });

    return updatedRecord.data.data;
};
